import { Link } from "react-router-dom";
import moment from "moment";
import PostMedia from "./PostMedia";
// import "../scss/sharedPost.scss";

const SharedPost = ({ post }) => {
    if (!post.originalPostId) return null;

    return (
        <div className="originalPost">
            <div className="originalUserInfo">
                <img 
                    src={
                        post.originalProfilePic?.startsWith("http") 
                        ? post.originalProfilePic 
                        : "/upload/" 
                        + post.originalProfilePic
                        || "/public/noAvatar.png"
                    } 
                    alt=""
                />

                <div className="details">
                    <Link 
                        to={`/profile/${post.originalUserId}`} 
                        style={{ textDecoration: "none", color: "inherit" }}
                    >
                        <span className="name">
                            {post.originalName}
                        </span>
                    </Link>

                    <span className="date">
                        {moment(post.originalCreatedAt).fromNow()}
                    </span>
                </div>
            </div>

            <Link 
                to={`/post/${post.originalPostId}`} 
                style={{ textDecoration: "none", color: "inherit", display: "block" }}
            >
                <div className="originalContent">
                    <p>
                        {post.originalDesc}
                    </p>

                    <PostMedia images={post.originalImg} postId={post.originalPostId} />
                </div>
            </Link>
        </div>
    );
};

export default SharedPost;